import { useEffect, useLayoutEffect } from "react";
import { useAuth } from "@workos-inc/authkit-react";
import { setTokenAccessor, setSessionEnder } from "@/shared/api/clients/tokenAccessor";
import { useSetOrgId } from "../../shared/auth/orgContext";

function decodeJwtPayload(token: string): Record<string, unknown> {
  const [, payload] = token.split(".");
  return JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
}

export function AuthTokenBridge() {
  const { getAccessToken, signOut, user } = useAuth();
  const setOrganizationId = useSetOrgId();

  useLayoutEffect(() => {
    setTokenAccessor(getAccessToken);
    setSessionEnder(() => {
      signOut({ returnTo: `${window.location.origin}/login` });
    });
  }, [getAccessToken, signOut]);

  useEffect(() => {
    if (!user) {
      setOrganizationId(null);
      return;
    }
    getAccessToken().then((token) => {
      const payload = decodeJwtPayload(token);
      setOrganizationId((payload.org_id as string) ?? null);
    });
  }, [user]);

  return null;
}
